__turbopack_context__.v({
  "modalContent": "ZapDeleteModal-module___Qowwq__modalContent",
  "permissionSpinner": "ZapDeleteModal-module___Qowwq__permissionSpinner",
});
